import _objectSpread from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.fill.js";
/* eslint-disable */
import editorStyle from '../util/defaultStyle';
import { getShapeName } from '../util/clazz';
import ControlPoint from '../item/controlPoint';
var Node = require('@antv/g6/lib/item/node');
var Edge = require('@antv/g6/lib/item/edge');
export default function (G6) {
  G6.registerNode('sub-process-node', {
    shapeType: 'rect',
    options: {
      icon: null,
      iconStyle: {
        width: 12,
        height: 12,
        left: 2,
        top: 2
      },
      style: _objectSpread(_objectSpread({}, editorStyle.nodeStyle), {}, {
        fill: '#FFFFFF',
        stroke: '#1890FF',
        cursor: 'default'
      }),
      stateStyles: {
        selected: {
          fill: '#E7F7FE'
        },
        addNode: {
          fill: '#E7F7FE'
        },
        hover: {
          cursor: editorStyle.cursor.hoverNode
        }
      }
    },
    drawControlPoints: function drawControlPoints(group) {
      var bbox = group.get('children')[0].getBBox();
      this.getControlPoints().forEach(function (p, i) {
        var anchorContainer = group.addGroup();
        var cursor = 'default';
        if (p[0] === 0 && p[1] === 0) {
          cursor = 'nwse-resize';
        } else if (p[0] === 0 && p[1] === 0.5) {
          cursor = 'ew-resize';
        } else if (p[0] === 1 && p[1] === 0) {
          cursor = 'nesw-resize';
        } else if (p[0] === 1 && p[1] === 0.5) {
          cursor = 'ew-resize';
        } else if (p[0] === 1 && p[1] === 1) {
          cursor = 'nwse-resize';
        } else if (p[0] === 0.5 && p[1] === 1) {
          cursor = 'ns-resize';
        } else if (p[0] === 0 && p[1] === 1) {
          cursor = 'nesw-resize';
        } else if (p[0] === 0.5 && p[1] === 0) {
          cursor = 'ns-resize';
        }
        var anchor = new ControlPoint({
          group: anchorContainer,
          index: i,
          model: {
            style: {
              x: bbox.minX + bbox.width * p[0],
              y: bbox.minY + bbox.height * p[1],
              cursor: cursor
            }
          }
        });
        // fuck 坑了好几天，全局注册的东西，在Item内部调用 Shape.getFactory('anchor') 查询不到。
        // 导致 item 初始化不成功。 只能暂时手工在外部把item 初始化了。 有点坑。
        // const shapeFactory = G6.Shape.getFactory('anchor');
        // anchor.set('shapeFactory', shapeFactory);
        // anchor.draw();
        anchor.toFront();
        group.controlPointShapes.push(anchorContainer);
        group.getAllAnchors = function () {
          return group.controlPointShapes;
        };
        group.getAnchor = function (j) {
          return group.controlPointShapes.filter(function (a) {
            return a.get('index') === j;
          });
        };
      });
    },
    drawNodes: function drawNodes(cfg, group) {
      var nodes = [];
      if (cfg.content && cfg.content.nodes) {
        cfg.content.nodes.forEach(function (nodeCfg) {
          var nodeContainer = group.addGroup();
          var node = new Node({
            group: nodeContainer,
            capture: false,
            id: nodeCfg.id,
            groupId: cfg.id,
            model: _objectSpread(_objectSpread({}, nodeCfg), {}, {
              shape: getShapeName(nodeCfg.clazz)
            })
          });
          node.toFront();
          nodeCfg.shape = getShapeName(nodeCfg.clazz);
          nodes.push(node);
        });
      }
      return nodes;
    },
    drawEdges: function drawEdges(cfg, group) {
      var edges = [];
      if (cfg.content && cfg.content.edges) {
        cfg.content.edges.forEach(function (edgeCfg) {
          var source = edgeCfg.source;
          var target = edgeCfg.target;
          if (source && G6.Util.isString(source)) {
            source = group.findById(source);
            source = source.get('item');
          }
          if (target && G6.Util.isString(target)) {
            target = group.findById(target);
            target = target.get('item');
          }
          var edgeContainer = group.addGroup();
          var edge = new Edge({
            group: edgeContainer,
            capture: false,
            source: source,
            target: target,
            id: edgeCfg.id,
            model: _objectSpread(_objectSpread({}, edgeCfg), {}, {
              shape: 'flow-polyline-round'
            })
          });
          edge.toFront();
          var model = edge.get('model');
          edgeCfg.startPoint = model.startPoint;
          edgeCfg.endPoint = model.endPoint;
          edgeCfg.shape = 'flow-polyline-round';
          edges.push(edge);
        });
      }
      return edges;
    },
    _addNode: function _addNode(node, cfg) {
      var nodeModel = node.get('model');
      var nodes = nodeModel.content ? nodeModel.content.nodes : [];
      var edges = nodeModel.content ? nodeModel.content.edges : [];
      nodes.push(cfg);
      return {
        content: {
          nodes: nodes,
          edges: edges
        }
      };
    },
    _addEdge: function _addEdge(node, cfg) {
      var nodeModel = node.get('model');
      var nodes = nodeModel.content ? nodeModel.content.nodes : [];
      var edges = nodeModel.content ? nodeModel.content.edges : [];
      edges.push(cfg);
      return {
        content: {
          nodes: nodes,
          edges: edges
        }
      };
    },
    _updateNode: function _updateNode(node, nodeId, cfg) {
      var nodeModel = node.get('model');
      var nodes = nodeModel.content ? nodeModel.content.nodes : [];
      var edges = nodeModel.content ? nodeModel.content.edges : [];
      var tempNode = nodes.find(function (a) {
        return a.id === nodeId;
      });
      Object.assign(tempNode, cfg);
      return {
        content: {
          nodes: nodes,
          edges: edges
        }
      };
    },
    _getItem: function _getItem(node, itemId) {
      var containerGroup = node.getContainer();
      return containerGroup.nodes.find(function (item) {
        return item.get('id') === itemId;
      });
    },
    _removeItem: function _removeItem(node, itemId) {
      var nodeModel = node.get('model');
      if (nodeModel && nodeModel.content) {
        var index = nodeModel.content.nodes.findIndex(function (item) {
          return item.id === itemId;
        });
        if (index !== -1) {
          nodeModel.content.nodes.splice(index, 1);
          return {
            content: nodeModel.content
          };
        } else {
          index = nodeModel.content.edges.findIndex(function (item) {
            return item.id === itemId;
          });
          if (index !== -1) {
            nodeModel.content.edges.splice(index, 1);
            return {
              content: nodeModel.content
            };
          }
        }
      }
      return {};
    },
    drawShape: function drawShape(cfg, group) {
      var _this = this;
      var shapeType = this.shapeType;
      var style = this.getShapeStyle(cfg);
      var shape = group.addShape(shapeType, {
        attrs: _objectSpread({}, style)
      });
      this.drawIcon(cfg, group);
      this.initAnchor(group);
      var subGroup = group.addGroup({
        id: 'sub_' + cfg.id
      });
      group.subGroup = subGroup;
      // 渲染内部Nodes
      var nodes = this.drawNodes(cfg, subGroup);
      // 渲染内部edges
      var edges = this.drawEdges(cfg, subGroup);
      group.nodes = nodes;
      group.edges = edges;
      group.controlPointShapes = [];
      group.showControlPoints = function (_group) {
        _this.drawControlPoints(_group);
      };
      group.clearControlPoints = function (_group) {
        if (_group.controlPointShapes) {
          _group.controlPointShapes.forEach(function (a) {
            return a.remove();
          });
        }
        _group.controlPointShapes = [];
      };
      group.addNodeModel = function (_node, _cfg) {
        return _this._addNode(_node, _cfg);
      };
      group.addEdgeModel = function (_node, _cfg) {
        return _this._addEdge(_node, _cfg);
      };
      group.updateNodeModel = function (_node, _itemId, _cfg) {
        return _this._updateNode(_node, _itemId, _cfg);
      };
      group.getItem = function (_node, _itemId) {
        return _this._getItem(_node, _itemId);
      };
      group.removeItem = function (_node, _itemId) {
        return _this._removeItem(_node, _itemId);
      };
      return shape;
    },
    setCustomState: function setCustomState(name, value, item) {
      var group = item.getContainer();
      if (name === 'selected') {
        var rect = group.getChildByIndex(0);
        if (value) {
          group.clearAnchor(group);
          group.showControlPoints(group);
          rect.attr('fill', this.options.stateStyles.selected.fill);
        } else {
          group.clearControlPoints(group);
          rect.attr('fill', this.options.style.fill);
        }
      }
    },
    getControlPoints: function getControlPoints() {
      return [[0, 0], [0.5, 0], [1, 0], [1, 0.5], [1, 1], [0.5, 1], [0, 1], [0, 0.5]];
    },
    getShapeStyle: function getShapeStyle(cfg) {
      if (!cfg.size || !Array.isArray(cfg.size)) {
        cfg.size = [80, 44];
      }
      var width = cfg.size[0];
      var height = cfg.size[1];
      var style = _objectSpread({
        x: 0 - width / 2,
        y: 0 - height / 2,
        width: width,
        height: height
      }, this.options.style);
      return style;
    },
    afterUpdate: function afterUpdate(cfg, node) {
      // TODO 因为没有改变 shape 所以不会更新
      var bbox = node.getBBox();
      var group = node.getContainer();
      var subGroup = group.subGroup;
      if (subGroup) {
        subGroup.clear();
        // 重新渲染内部Nodes
        var nodes = this.drawNodes(cfg, subGroup);
        // 重新渲染内部edges
        var edges = this.drawEdges(cfg, subGroup);
        group.nodes = nodes;
        group.edges = edges;
      }
    }
  }, 'base-node');
}